import { LOAN_REQUEST_OFFER_STATUS } from 'cpool-constants';
import { z } from 'zod';

export const OfferFilterCriteria = z.object({
    favored: z.boolean().optional(),
    teaser: z.boolean().optional(),
});
export type Schema_OfferFilterCriteria = z.infer<typeof OfferFilterCriteria>;

export const OfferFilterStatus = z.array(z.nativeEnum(LOAN_REQUEST_OFFER_STATUS));
export type Schema_OfferFilterStatus = z.infer<typeof OfferFilterStatus>;

export const OfferFilter = z
    .object({
        criteria: OfferFilterCriteria.optional(),
        status: OfferFilterStatus.optional(),
    })
    .nullable();
export type Schema_OfferFilter = z.infer<typeof OfferFilter>;
